// HACK: does nothing, because `toPromise` now lives on the `Observable` itself.
// leaving this module here to prevent breakage.
//# sourceMappingURL=toPromise.js.map


// WEBPACK FOOTER //
// ./techpad-upgrade/~/rxjs/add/operator/toPromise.js